if (!customElements.get('indriya-product-experience')) {
  customElements.define('indriya-product-experience', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('dialog');
      this.gallery = this.querySelector('.ij-pdp__media-list');
      this.controls = this.querySelector('.ij-pdp__gallery-controls');

      this.addEventListener('click', (event) => {
        const imageLink = event.target.closest('[data-zoom-link]');
        if (imageLink && !event.metaKey && !event.ctrlKey) {
          event.preventDefault();
          this.zoomTrigger = imageLink;
          const image = this.dialog.querySelector('[data-zoom-image]');
          image.src = imageLink.href;
          image.alt = imageLink.querySelector('img').alt;
          this.dialog.querySelector('[data-zoom-caption]').textContent = image.alt;
          this.dialog.showModal();
          document.body.classList.add('ij-image-zoom-open');
        }
        const detailsLink = event.target.closest('[data-open-details]');
        if (detailsLink) {
          event.preventDefault();
          const details = this.querySelector(detailsLink.getAttribute('href'));
          details.open = true;
          details.scrollIntoView({ behavior: this.scrollBehavior, block: 'nearest' });
          details.querySelector('summary').focus({ preventScroll: true });
        }
      }, options);

      this.dialog.addEventListener('close', () => {
        document.body.classList.remove('ij-image-zoom-open');
        this.zoomTrigger?.focus({ preventScroll: true });
      }, options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      }, options);

      if (this.controls) {
        this.controls.hidden = false;
        this.previous = this.controls.querySelector('[data-gallery-previous]');
        this.next = this.controls.querySelector('[data-gallery-next]');
        this.previous.addEventListener('click', () => this.moveGallery(-1), options);
        this.next.addEventListener('click', () => this.moveGallery(1), options);
        this.gallery.addEventListener('scroll', () => this.updateGallery(), { ...options, passive: true });
        this.resizeObserver = new ResizeObserver(() => this.updateGallery());
        this.resizeObserver.observe(this.gallery);
        this.updateGallery();
      }

      this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (data.sectionId !== this.dataset.section) return;
        const quantity = this.querySelector('input[name="quantity"]');
        const updatedQuantity = data.html.querySelector('.ij-pdp__form input[name="quantity"]');
        if (quantity && updatedQuantity) quantity.value = updatedQuantity.value;
        const submit = this.querySelector('.ij-pdp__submit');
        const buttonText = this.querySelector('.ij-pdp__submit > span');
        if (data.variant.available && !submit.disabled && buttonText) buttonText.textContent = 'Add to bag';
        this.updateGallery();
      });
    }

    get scrollBehavior() {
      return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    }

    moveGallery(direction) {
      this.gallery.scrollBy({ left: direction * this.gallery.clientWidth, behavior: this.scrollBehavior });
    }

    updateGallery() {
      if (!this.controls || !this.gallery.clientWidth) return;
      const index = Math.round(this.gallery.scrollLeft / this.gallery.clientWidth);
      this.controls.querySelector('[data-gallery-current]').textContent = index + 1;
      this.previous.disabled = index === 0;
      this.next.disabled = index >= this.gallery.children.length - 1;
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.unsubscribeVariant?.();
      if (this.dialog?.open) this.dialog.close();
      document.body.classList.remove('ij-image-zoom-open');
    }
  });
}
